import { SHStack } from "@components/design-systems";
import { Collapse } from "@mui/material";
import { useToggle } from "react-use";
import { MSTableFilterSectionTitle } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/filter-section/title";
import { MSTableFilterItem } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/filter-item";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { useWindowWidth } from "@react-hook/window-size";
import { MSFilterDefaultValueConstants } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/constants";
import { ModelScreenerFilterSectionDTO } from "@models/model-screener/entities/modelScreenerFilter";

type MSFilterSectionProps = {
  section: ModelScreenerFilterSectionDTO;
  disabled?: boolean;
};

export const MSFilterSection = ({ section, disabled }: MSFilterSectionProps) => {
  const preComputedItemPaths = useSelector(
    (state: RootState) => state.modelScreener.internal.filterItemFieldPaths,
  );
  const windowWidth = useWindowWidth();

  // States
  const [isOpen, toggleIsOpen] = useToggle(true);

  const renderFilterItems = () => {
    const sectionItems = section.items ?? [];
    if (!sectionItems || sectionItems.length === 0 || !preComputedItemPaths)
      return null;

    return sectionItems.map((item, index) => {
      return (
        <MSTableFilterItem
          key={index}
          disabled={disabled}
          item={item}
          itemPaths={preComputedItemPaths[item.id]}
          itemSize={windowWidth < 1280 ? "small" : "medium"}
        />
      );
    });
  };

  return (
    <SHStack
      width={"100%"}
      p={"12px"}
      bgcolor={"#F2F1FF"}
      borderRadius={"12px"}
      gap={isOpen ? 1 : 0}
      sx={{
        transition: "gap 0.3s ease-in-out",
      }}
    >
      <MSTableFilterSectionTitle
        title={section.name}
        isOpen={isOpen}
        onClick={toggleIsOpen}
      />
      <Collapse
        in={isOpen}
        unmountOnExit={false}
        timeout={MSFilterDefaultValueConstants.StandardDelayTimeMs}
      >
        <SHStack width={"100%"} gap={1.5}>
          {renderFilterItems()}
        </SHStack>
      </Collapse>
    </SHStack>
  );
};
